// Separate loading states enum for better state management
export const LoadingState = {
  INITIAL: "initial",
  LOADING: "loading",
  ERROR: "error",
  SUCCESS: "success",
} as const;

export type LoadingStateType = (typeof LoadingState)[keyof typeof LoadingState];
